import React from "react";
import "./ticketDetail.style";
import { Grid } from '@mui/material';
import moment from "moment-timezone";
import { NOT_APPLICABLE } from '../../../constants/originalState';

export interface NoScanReason {
  label: string;
  value: string;
}

export interface IAcknowledgementProps {
  infoTicket: any,
  locale: any
  noScanReasons?: NoScanReason[];
};

const Acknowledgement = (props: IAcknowledgementProps) => {
  const { infoTicket, locale, noScanReasons = [] } = props;
  const variableInfo = infoTicket.variables;

  const noScanReasonValue = variableInfo?.json_storage?.no_scan_reason;
  const noScanReasonLabel = noScanReasons.find((reason) => reason.value === noScanReasonValue)?.label;
  const noScanReason = noScanReasonLabel || noScanReasonValue;

  return (
    <Grid container>
      <Grid item xs={12}>
        <p className="ttl-col-desc">{locale?.moreDetails}</p>
        <p className="value-info value-capitalize" id="lbl-acknowledgement-moredetails">{NOT_APPLICABLE}</p>
      </Grid>
      <Grid item xs={6} className="pr-20">
        <p className="ttl-col-desc">{locale?.acknowledgedDevice}</p>
        <p className="value-info" id="lbl-acknowledgement-serial_number">
          <strong>{locale?.serialNumber}:</strong> {variableInfo?.asset?.serial_number || NOT_APPLICABLE}
        </p>
        <p className="value-info" id="lbl-acknowledgement-model">
        <strong>{locale?.modelName}:</strong> {variableInfo?.asset?.model || NOT_APPLICABLE}
        </p>
      </Grid>
      <Grid item xs={6} className="pr-20">
        <p className="ttl-col-desc">{locale?.dateAcknowledged}</p>
        <p className="value-info value-capitalize" id="lbl-acknowledgement-last_discovered">
          {moment(variableInfo?.asset?.last_discovered).format('MM/DD/YYYY') || NOT_APPLICABLE}
        </p>
      </Grid>
      {!!noScanReason && <Grid item xs={6} className="pr-20">
        <p className="ttl-col-desc">{locale?.noScanReason}</p>
        <p className="value-info value-capitalize" id="lbl-acknowledgement-no_scan_reason">
          {noScanReason || NOT_APPLICABLE}
        </p>
      </Grid>}
    </Grid>
  );
};

export default Acknowledgement;
